import { Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ProtectedRoute } from '@/components/routing';

// Lazy load admin pages
const Admin = lazy(() => import('@/pages/Admin'));
const TauxReussite = lazy(() => import('@/pages/TauxReussite'));
const PromoCodesManager = lazy(() => import('@/components/admin/promo-codes/PromoCodesManager'));
const PromoCodeForm = lazy(() => import('@/components/admin/promo-codes/PromoCodeForm'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function AdminRoutes() {
  return (
    <>
      {/* Route principale admin */}
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute requireAdmin>
            <Suspense fallback={<PageLoader />}>
              <Admin />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      
      {/* Redirections des anciennes URLs modulaires vers les tabs */}
      <Route path="/admin/dashboard" element={<Navigate to="/admin?tab=dashboard" replace />} />
      <Route path="/admin/users" element={<Navigate to="/admin?tab=users" replace />} />
      <Route path="/admin/financing" element={<Navigate to="/admin?tab=financing" replace />} />
      <Route path="/admin/payments" element={<Navigate to="/admin?tab=payments" replace />} />
      <Route path="/admin/content" element={<Navigate to="/admin?tab=content" replace />} />
      <Route path="/admin/emails" element={<Navigate to="/admin?tab=emails" replace />} />
      <Route path="/admin/integrations" element={<Navigate to="/admin?tab=integrations" replace />} />
      <Route path="/admin/security" element={<Navigate to="/admin?tab=security" replace />} />
      <Route path="/admin/system" element={<Navigate to="/admin?tab=security" replace />} />
      <Route path="/admin/system/feature-flags" element={<Navigate to="/admin?tab=feature-flags" replace />} />
      
      {/* Routes spéciales avec leurs propres pages */}
      <Route 
        path="/admin/taux-reussite" 
        element={
          <ProtectedRoute requireAdmin>
            <Suspense fallback={<PageLoader />}>
              <TauxReussite />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/promo-codes" 
        element={
          <ProtectedRoute requireAdmin>
            <Suspense fallback={<PageLoader />}>
              <PromoCodesManager />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/promo-codes/new" 
        element={
          <ProtectedRoute requireAdmin>
            <Suspense fallback={<PageLoader />}>
              <PromoCodeForm />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/promo-codes/:id" 
        element={
          <ProtectedRoute requireAdmin>
            <Suspense fallback={<PageLoader />}>
              <PromoCodeForm />
            </Suspense>
          </ProtectedRoute>
        } 
      />
    </>
  );
}
